// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zigzagoon_galar: PokeData = {
  "id": 10174,
  "name": "zigzagoon-galar",
  "height": 4,
  "weight": 175,
  "base_experience": 56,
  "types": [
    PokeType.DARK,
    PokeType.NORMAL
  ],
  "api_moves": [
    "sand-attack",
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "pin-missile",
    "leer",
    "counter",
    "lick",
    "rest",
    "scary-face",
    "taunt",
    "snarl",
    "baby-doll-eyes"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "pin-missile",
    "leer",
    "lick",
    "scary-face",
    "snarl",
    "supersonic",
    "tri-attack",
    "night-slash",
    "lash-out",
    "refresh",
    "splash"
  ],
  "evolution_chain": {
    "id": 134,
    "item": null,
    "species": [
      {
        "name": "zigzagoon",
        "order": 288,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "linoone",
        "order": 289,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 263,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "obstagoon",
        "order": 862,
        "types": [
          PokeType.DARK,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 264,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 79,
    "speed": 120,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
